import req from '../../api/request'
import type { HomeCalendarData } from './types'

/** Empty feed, used when the response carries no `data`. */
const EMPTY: HomeCalendarData = {
  previousGames: [],
  upcomingGames: [],
  previousEvents: [],
  upcomingEvents: [],
  myTeams: [],
}

/**
 * The home screen's combined feed — the viewer's games AND events, past and
 * upcoming, across every team they follow.
 *
 * Replaces `/home/games`, whose game/team keys this returns unchanged; the two
 * event arrays are the addition. One request now backs both the game widgets
 * and the upcoming-events widget.
 *
 * Each array is defaulted rather than left undefined, so a caller can map over
 * it without guarding — a feed with no events omits the key entirely rather
 * than sending `[]`.
 */
export const getHomeCalendar = async (): Promise<HomeCalendarData> => {
  const response = await req('/home/calendar')
  const data = response?.data as Partial<HomeCalendarData> | undefined

  if (!data) {
    return EMPTY
  }

  return {
    previousGames: data.previousGames ?? [],
    upcomingGames: data.upcomingGames ?? [],
    previousEvents: data.previousEvents ?? [],
    upcomingEvents: data.upcomingEvents ?? [],
    myTeams: data.myTeams ?? [],
  }
}
